import { useState } from "react";
import { Link } from "react-router";
import { Aviso, Chip } from "../ui";
import { mensagemDoConsole } from "../../nucleo/console";
import {
  ROTULO_DA_DECISAO,
  ROTULO_DO_RESULTADO,
  useEmailsRecebidos,
  type EmailRecebido,
} from "../../nucleo/canais";
import { quandoLegivel } from "../../nucleo/automacao";
import { CampoDeEscolha } from "../automacao/apoio";

const FILTROS = [
  { valor: "quarentena", rotulo: ROTULO_DO_RESULTADO.quarentena },
  { valor: "ignorado", rotulo: ROTULO_DO_RESULTADO.ignorado },
  { valor: "chamado", rotulo: ROTULO_DO_RESULTADO.chamado },
  { valor: "acao", rotulo: ROTULO_DO_RESULTADO.acao },
] as const;

function estadoDoChip(item: EmailRecebido) {
  if (item.resultado === "quarentena") return item.decisao === "liberada" ? "ok" : item.decisao ? "neutro" : "atencao";
  return item.resultado === "ignorado" ? "neutro" : "ok";
}

export function PainelDeEmailsRecebidos() {
  const [filtro, setFiltro] = useState<EmailRecebido["resultado"] | "">("");
  const emails = useEmailsRecebidos(filtro);
  return (
    <section aria-labelledby="titulo-emails">
      <h2 className="titulo-secao" id="titulo-emails">E-mails recebidos</h2>
      <CampoDeEscolha
        rotulo="Mostrar"
        valor={filtro}
        aoMudar={(valor) => setFiltro(valor as EmailRecebido["resultado"] | "")}
        vazio="Todos"
        opcoes={FILTROS}
      />
      {emails.isPending ? <p role="status">Carregando e-mails…</p> : null}
      {emails.isError ? <Aviso tom="erro">{mensagemDoConsole(emails.error)}</Aviso> : null}
      {emails.data && emails.data.length === 0 ? <Aviso tom="marca">Nenhum e-mail recebido ainda.</Aviso> : null}
      <ul className="lista-de-itens" data-testid="lista-de-emails">
        {emails.data?.map((item) => (
          <li key={item.id} data-testid={`email-${item.resultado}`}>
            <Chip estado={estadoDoChip(item)}>
              {item.decisao ? ROTULO_DA_DECISAO[item.decisao] : ROTULO_DO_RESULTADO[item.resultado]}
            </Chip>{" "}
            <b>{item.assunto || "(sem assunto)"}</b> · <code>{item.remetente ?? "remetente ilegível"}</code> ·{" "}
            {quandoLegivel(item.recebido_em)}
            {item.ticket_id && item.numero_do_ticket ? (
              <>
                {" "}· <Link to={`/admin/chamados/${item.ticket_id}`}>chamado #{item.numero_do_ticket}</Link>
              </>
            ) : null}
            {item.motivo ? <p className="nota-rodape">{item.motivo}</p> : null}
          </li>
        ))}
      </ul>
    </section>
  );
}
